module.exports = __webpack_public_path__ + "static/media/Papermoon Puppet Theatre.3b7f0be8.jpg";